import DashNav3 from "../components/DashNav3";
import '../styling/NewCreateClient.css'
import backarrow from '../resources/backarrow.png'
import { Link } from "react-router-dom";
import { useState } from "react";
import NewCreateClientForm from "../components/NewCreateClientForm";


const NewCreateClient = () => {
    const [error,setError] = useState("")
    const[success,setSuccess] = useState("")

    const updateError = (errormessage) => {
        setSuccess('')
        setError(errormessage)
    }

    const updateSuccess = (successmessage) => {
        setError('')
        setSuccess(successmessage)
    }

    return ( 
        <div className="newcreateclientcontainer">
            <DashNav3></DashNav3>
            <div className="newcreateclientright">
            <div className="error2">
            {error && 
            <div className="alert alert-error" id="createclientsuccess">
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span>Error! {error}</span>
            </div>}
            {success && 
            <div className="alert alert-success" id="createclientsuccess">
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <span>{success}</span>
          </div>}
            </div> 
                <div className="newcreatetop">
                    <div className="createtopleft">
                    <Link to="/clients" style={{textDecoration: 'none'}}>
                    <img src={backarrow} alt="" />
                    </Link>
                    <h1 className="text-3xl font-bold">Create a client</h1>
                    </div>
                </div>
                <hr id="newline1"/>
                <NewCreateClientForm updateError={updateError} updateSuccess={updateSuccess}></NewCreateClientForm>
            </div>
        </div>
    );
}
 
export default NewCreateClient;